import Component from '@glimmer/component'
import { htmlSafe } from '@ember/template'

interface Args {
  progressPercent?: number
}

interface Signature {
  Args: Args
  Element: HTMLDivElement
}

export class UploadProgress extends Component<Signature> {
  get progressBarStyle() {
    return htmlSafe(`width: ${this.args.progressPercent ?? 0}%`)
  }

  <template>
    <div class="h-6 overflow-hidden rounded-md bg-dusty-black-50" ...attributes>
      <div
        class="max-w-100% h-full bg-oceany-blue-300 text-center text-white"
        role="progressbar"
        style={{this.progressBarStyle}}
      >
        {{@progressPercent}}%
      </div>
    </div>
  </template>
}

export default UploadProgress
